var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    "data-testid": "money-icon-button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-menu-logged-out-tablet",
    transform: "translate(-770 -128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(675 119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(96)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 14,
    cy: 14,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "cash",
    transform: "translate(4 4)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 .175C4.604.175.175 4.604.175 10c0 5.396 4.429 9.825 9.825 9.825 5.396 0 9.825-4.429 9.825-9.825 0-5.396-4.429-9.825-9.825-9.825zm3.156 14.152c-.458.56-1.12.968-1.832 1.171-.306.102-.459.255-.459.56v.967c0 .306-.152.459-.407.459H9.39c-.305 0-.458-.153-.458-.459v-.712c0-.51 0-.56-.51-.611-.661-.102-1.272-.255-1.832-.51-.458-.203-.509-.356-.356-.814l.305-1.069c.102-.254.153-.356.306-.356.101 0 .203.05.305.102.662.356 1.324.509 2.036.61h.357c.356 0 .662-.05.967-.203.815-.357.916-1.273.255-1.833-.255-.204-.51-.305-.764-.458-.713-.306-1.425-.56-2.087-.967-1.07-.662-1.782-1.528-1.68-2.851.102-1.477.916-2.393 2.29-2.902.56-.204.56-.204.56-.764v-.61c0-.459.102-.51.51-.51h.509c.814 0 .814.051.814.917 0 .661 0 .661.662.763.51.102.967.204 1.477.458.254.102.356.306.254.56-.102.408-.204.815-.356 1.222-.102.255-.153.357-.306.357-.102 0-.152-.051-.305-.102a4.755 4.755 0 00-2.037-.458h-.254c-.204 0-.407.05-.611.101-.713.306-.815 1.07-.204 1.579.306.254.662.407 1.019.56.61.254 1.221.509 1.832.814 1.884 1.018 2.342 3.36 1.07 4.99z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  })))))))));
}
SvgMoneyIcon.displayName = 'MoneyIcon';
export default SvgMoneyIcon;